export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selection/size.js
// module id = ../../../../d3-selection/src/selection/size.js
// module chunks = 4